import { IClient } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorHasPaymentMethod = (client?: IClient) =>
  !!client?.profile.defaultPaymentMethod?.accountId ||
  !!client?.profile.defaultPaymentMethod?.paymentMethodId;
